import React, { useEffect, useState } from 'react';
import Banner from '../../components/sub-profile/banner';
import ErrorView from '../../components/sub-profile/error';
import Loading from '../../components/sub-profile/loading';
import Navbar from '../../components/sub-profile/navbar';
import Profile from '../../components/sub-profile/profile';
import config from '../../configs/config';

export const getTaxIDFromURL = () => {
  const path = window.location.pathname.split('/');
  return path.pop();
};

export const getSubProfile = async setSubProfile => {
  const serverUrl = config.serverUrl;
  const taxId = getTaxIDFromURL();

  try {
    const url = `${serverUrl}/public/company/${taxId}`;
    const response = await fetch(url);
    if (response.status === 200) {
      const data = await response.json();
      return setSubProfile({
        isFetching: false,
        data
      });
    }
    return setSubProfile({
      isFetching: false,
      error: 'Unable to fetch the data'
    });
  } catch (error) {
    let message = 'Unknown Error';
    if (error instanceof Error) message = error.message;
    return setSubProfile({
      isFetching: false,
      error: message
    });
  }
};

const initialSubProfile = {
  isFetching: true
};

export const resolveSubProfileData = subProfile => {
  if (subProfile.isFetching) return <Loading />;

  if (subProfile.data) return <Profile profile={subProfile.data} />;

  if (subProfile.error) return <ErrorView error={subProfile.error} />;
};

export const Subprofile = () => {
  const [subProfile, setSubProfile] = useState(initialSubProfile);

  useEffect(() => {
    getSubProfile(setSubProfile);
  }, []);

  return (
    <>
      <Navbar />
      <Banner />
      {resolveSubProfileData(subProfile)}
    </>
  );
};

export default Subprofile;
